export default {
  data() {
    return {
      tabHeight: null,
      contentHeight: null,
    }
  },
  methods: {
    layoutHeight() {
      this.tabHeight = document.getElementsByClassName('fn-layout-vertical-form')[0] ? document.getElementsByClassName('fn-layout-vertical-form')[0].offsetHeight : 0;
      this.contentHeight = document.getElementsByClassName('fn-layout-vertical-table')[0] ? document.getElementsByClassName('fn-layout-vertical-table')[0].offsetHeight : 0;
    },
  },
  mounted() {
    this.$store.dispatch(
      "tagsView/removeExcludePageData",
      this.$options.name
    );
    this.layoutHeight();
  },
  updated() {
    this.layoutHeight();
  },
  activated() {
    window.onresize = () => {
      this.layoutHeight();
    };
  },
  deactivated() {
    window.onresize = null
  },
}



// WEBPACK FOOTER //
// ./src/layout/Home/mixin/RisizeTable.js